import {
  configureStore
} from "@reduxjs/toolkit";
import adminMenuReducer from "../slice/admin/adminMenuSlice";
import userReducer from "../slice/user/userSlice";
import authReducer from "../slice/auth/authSlice";
import categoryReducer from "../slice/category/categorySlice";
import subCategoryReducer from "../slice/subCategory/subCategorySlice";
import colorReducer from "../slice/color/colorSlice";
import sizeReducer from "../slice/size/sizeSlice";
import productReducer from "../slice/product/productSlice";
import cartReducer from "../slice/cart/cartSlice";
import adminUserReducer from "../slice/adminUser/adminUserSlice";
import checkoutReducer from "../slice/checkout/checkoutSlice";
import orderReducer from "../slice/order/orderSlice";
import favouriteReducer from "../slice/favourite/favouriteSlice";
import dashboardReducer from '../slice/dashboard/Dashboardslice';
import searchReducer from '../slice/search/searchSlice';
import labelReducer from "../slice/label/labelSlice";
import bannerReducer from "../slice/banner/bannerSlice";
import couponsReducer from "../slice/coupons/couponSlice";
import permissionReducer from "../slice/permission/permissionSlice";
import addressReducer from "../slice/address/addressSlice";
import manualOrderReducer from "../slice/manual/manualorderslice";
export const store = configureStore({
  reducer: {
    adminMenu: adminMenuReducer,
    user: userReducer,
    auth: authReducer,
    category: categoryReducer,
    subCategory: subCategoryReducer,
    color: colorReducer,
    size: sizeReducer,
    product: productReducer,
    cart: cartReducer,
    adminUser: adminUserReducer,
    checkout: checkoutReducer,
    orders: orderReducer,
    favourite: favouriteReducer,
    dashboard: dashboardReducer,
    search: searchReducer,
     label: labelReducer, 
     banner: bannerReducer, 
     coupon: couponsReducer, 
     permission: permissionReducer,
     address: addressReducer,
     manualOrders: manualOrderReducer

  }
});